import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=d52e4820&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"
import style0 from "./TreeItem.vue?vue&type=style&index=0&id=d52e4820&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52e4820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52e4820')) {
      api.createRecord('d52e4820', component.options)
    } else {
      api.reload('d52e4820', component.options)
    }
    module.hot.accept("./TreeItem.vue?vue&type=template&id=d52e4820&scoped=true", function () {
      api.rerender('d52e4820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/groups/TreeItem.vue"
export default component.exports